import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import { TechCoverSoftwareRelease } from "../models/TechCoverSoftwareRelease";

@Injectable({
  providedIn: "root",
})
export class TechCoverSoftwareReleaseService {
  private baseUrl_V2 = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/techCoverSoftwareReleases`;

  constructor(private http: HttpClient) {}

  public getSoftwareReleases(companyId: string): Promise<TechCoverSoftwareRelease[]> {
    return firstValueFrom(
      this.http.get<TechCoverSoftwareRelease[]>(`${this.baseUrl_V2}/${companyId}`),
    );
  }

  public getReleaseNoteUrl(companyId: string, softwareMetadataId: number): Promise<string> {
    return firstValueFrom(
      this.http.get<string>(
        `${this.baseUrl_V2}/${companyId}/releaseNotesUrl/${softwareMetadataId}`,
      ),
    );
  }

  public getSoftwareDownloadUrl(companyId: string, softwareMetadataId: number): Promise<string> {
    return firstValueFrom(
      this.http.get<string>(
        `${this.baseUrl_V2}/${companyId}/softwareDownloadUrl/${softwareMetadataId}`,
      ),
    );
  }
}
